<template>
  <k-editor-form large-buttons>
    <template #left v-if="logs">

      <k-data-table :headers="headers" :items="sorted_logs" hide-actions disable-initial-sort>
        <template slot="items" slot-scope="props">
          <tr>
          <td style="min-width: 250px;">{{props.item.meta.comment}}</td>
          <td>{{get_content(props.item.device_data.status, "name")}}</td>
          <td>{{get_content(props.item.device_data.location, "name")}}</td>
          <td>{{get_account(props.item.account_id)}}</td>
          <td>{{format_date(props.item.updated_at)}}</td>
          <td class="hidden-sm-and-down" style="text-align: right; min-width: 50px; max-width: 50px; width: 50px;">
          </td>
          </tr>
        </template>
      </k-data-table>

    </template>
    <template #left-buttons>
      <log :id="id" ref="log" style="width: 100%;"></log>
    </template>
    <template #right-buttons v-if="logs">
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>
<script>
import moment from 'moment';
import Log from './Log'

export default {
  props: ["id"],
  components: {
    Log
  },
  data () {
    var ch = {};
    if (typeof(this.id) != "undefined") {
      ch = this.$cloudserver.channel("devices:logs:"+this.id);
    }
    return {
      ws_channel: ch,
      logs: this.convertLogs(ch.data),
      device_log: {meta: {}},
      headers: [
        { text: 'Comment', value: 'meta.comment', align: 'left' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Location', value: 'location', align: 'left'},
        { text: 'Creator', value: 'creator', align: 'left' },
        { text: 'Date', value: 'date', align: 'left'},  
        { text: 'Actions', align: 'right', class: "hidden-sm-and-down"}

      ],  
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.logs = this.convertLogs(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        if (typeof(this.id) != "undefined") {
          this.ws_channel = this.$cloudserver.channel("devices:logs:"+this.id);
          this.ws_channel.join();
        }
      }
    }
  },  
  created() {
    if (typeof(this.id) != "undefined") {
      this.ws_channel.join();
    }
  },
  computed: {
    sorted_logs() {
      var sorted = _.sortBy(this.logs, function(log) {
        var d = moment.utc(log.updated_at).local();
        return d.format("X");
      });
      return _.reverse(sorted);
    }
  },
  methods: {
    get_type_title(type) {
      return type;
    },
    get_content(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field.data[name];
      }
      return "";
    },
    get_account(id) {
      return this.$store.state.accounts[id].email;
    },
    format_date(date) {
      var d = moment.utc(date).local();
      return d.format("DD.MM.YYYY HH:mm");
    },
    convertLogs (newVal, oldVal) {
      var logs = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      if(typeof(logs) == "undefined" || _.isEmpty(logs)) return undefined;
      return logs;
    },
    save (close) {
      this.$refs.log.save(close);

    }
  }
}
</script>